/**
 * FAQ accordion module
 * Handles FAQ toggle functionality
 */

/**
 * Toggles the visibility of FAQ content sections
 * @param {string} faqId - The base ID of the FAQ element to toggle
 * @param {Document} doc - The document object
 * @returns {boolean} True if content is now visible, false if hidden
 */
export function toggleFAQ(faqId, doc = document) {
  const content = doc.getElementById(faqId + '-content');
  const icon = doc.getElementById(faqId + '-icon');

  if (!content) return false;

  const isHidden = content.classList.contains('hidden');

  if (isHidden) {
    content.classList.remove('hidden');
    if (icon) {
      icon.style.transform = 'rotate(180deg)';
    }
    return true;
  } else {
    content.classList.add('hidden');
    if (icon) {
      icon.style.transform = 'rotate(0deg)';
    }
    return false;
  }
}

/**
 * Opens a specific FAQ section
 * @param {string} faqId - The base ID of the FAQ element
 * @param {Document} doc - The document object
 */
export function openFAQ(faqId, doc = document) {
  const content = doc.getElementById(faqId + '-content');
  const icon = doc.getElementById(faqId + '-icon');

  if (!content) return;

  content.classList.remove('hidden');
  if (icon) {
    icon.style.transform = 'rotate(180deg)';
  }
}

/**
 * Closes a specific FAQ section
 * @param {string} faqId - The base ID of the FAQ element
 * @param {Document} doc - The document object
 */
export function closeFAQ(faqId, doc = document) {
  const content = doc.getElementById(faqId + '-content');
  const icon = doc.getElementById(faqId + '-icon');

  if (!content) return;

  content.classList.add('hidden');
  if (icon) {
    icon.style.transform = 'rotate(0deg)';
  }
}

/**
 * Checks if a FAQ section is currently open
 * @param {string} faqId - The base ID of the FAQ element
 * @param {Document} doc - The document object
 * @returns {boolean} True if open, false if closed
 */
export function isFAQOpen(faqId, doc = document) {
  const content = doc.getElementById(faqId + '-content');
  if (!content) return false;
  return !content.classList.contains('hidden');
}
